module.exports = __webpack_public_path__ + "img/project-9.9c6886b0.png";